// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

type Props = {
  classes: Object,
  className: string,
  title: string,
};

const OAuthGoogle = ({ classes, className, title, ...rest }: Props) => (
  <a className={classNames(classes.root, className)} {...rest}>
    <svg
      width={16}
      height={16}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      style={{
        flexShrink: "0",
        marginRight: "6px",
      }}
    >
      <path
        d="M11 24a13.06 13.06 0 0 1 .66-4.08l-7.4-5.67a22.18 22.18 0 0 0 0 19.49l7.4-5.67A13 13 0 0 1 11 24z"
        fill="#fbbc05"
      />
      <path
        d="M24 11a12.72 12.72 0 0 1 8.1 2.9l6.4-6.4a22 22 0 0 0-34.24 6.75l7.4 5.67A13 13 0 0 1 24 11z"
        fill="#ea4335"
      />
      <path
        d="M24 37a13 13 0 0 1-12.35-8.93l-7.4 5.67A21.93 21.93 0 0 0 24 46a20.94 20.94 0 0 0 14.33-5.48l-7-5.44A13.62 13.62 0 0 1 24 37z"
        fill="#34a853"
      />
      <path
        d="M24 20v8.5h11.8a9.93 9.93 0 0 1-4.49 6.58l7 5.44C42.37 36.76 45 31.17 45 24a18.25 18.25 0 0 0-.5-4z"
        fill="#4285f4"
      />
    </svg>
    <span>{title}</span>
  </a>
);

const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    padding: "18px 8px",
    fontSize: "13px",
    fontWeight: "600",
    textAlign: "center",
    borderRadius: theme.globalBorderRadius,
    textDecoration: "none",
    color: "inherit",
  },
});

export default withStyles(styles)(OAuthGoogle);
